import { Modal } from '@mantine/core';
import { useIsMobile } from '../../hooks/useIsMobile.js';
import { PushResult } from './PushResult.js';
import { PushReview } from './PushReview.js';
import { usePushWorkflow } from './usePushWorkflow.js';
import type { PushRequest } from './pushSummary.js';

/** Review → confirm → result, one modal. Keyed on the request so a new request starts clean. */
export const PushModal = ({ request, onClose }: { request: PushRequest | null; onClose: () => void }) =>
    request ? <PushWorkflow key={JSON.stringify(request)} request={request} onClose={onClose} /> : null;

const PushWorkflow = ({ request, onClose }: { request: PushRequest; onClose: () => void }) => {
    const isMobile = useIsMobile();
    const workflow = usePushWorkflow(request);

    return (
        <Modal
            opened
            onClose={onClose}
            fullScreen={isMobile}
            size="min(1200px, 96vw)"
            radius="lg"
            padding={0}
            withCloseButton={false}
            styles={{
                content: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: workflow.result ? undefined : isMobile ? '100dvh' : 'min(840px, 92vh)',
                },
            }}
            overlayProps={{ backgroundOpacity: 0.45, blur: 2 }}
        >
            {workflow.result ? (
                <PushResult result={workflow.result} onClose={onClose} />
            ) : (
                <PushReview request={request} workflow={workflow} onCancel={onClose} />
            )}
        </Modal>
    );
};
